import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthenticationGuard, PipefyLogoutGuard } from '@app/guards';

import { DocumentsHomeComponent } from './documents-home/documents-home.component';
import { DocumentsListComponent } from './documents-list/documents-list.component';
import { DocumentsTrashbinListComponent } from './documents-trashbin-list/documents-trashbin-list.component';
import { DocumentsGroupListComponent } from './documents-group-list/documents-group-list.component';
import { DocumentsOrganizationListComponent } from './documents-organization-list/documents-organization-list.component';
import { DocumentsOrganizationMemberListComponent } from './documents-organization-member-list/documents-organization-member-list.component';
import { FoldersListComponent } from './folders-list/folders-list.component';
import { ContactsListComponent } from './contacts-list/contacts-list.component';
import { DocumentsNewComponent } from './documents-new/documents-new.component';
import { DocumentsEditComponent } from './documents-edit/documents-edit.component';
import { DocumentsFieldsEditComponent } from './documents-fields-edit/documents-fields-edit.component';
import { DocumentsShowComponent } from './documents-show/documents-show.component';
import { DocumentsTemplateComponent } from './documents-templates/documents-template.component';
import { DocumentsFillTemplateComponent } from './documents-templates/fill-template/fill-template.component';
import { DocumentsDynamicTemplatesComponent } from './documents-dynamic-templates/documents-dynamic-templates.component';
import { FillDynamicTemplateComponent } from './documents-dynamic-templates/fill-dynamic-template/fill-dynamic-template.component';

const routes: Routes = [
  {
    path: 'documentos',
    component: DocumentsHomeComponent,
    canActivate: [AuthenticationGuard, PipefyLogoutGuard],
    children: [
      { path: '', redirectTo: '/documentos/todos', pathMatch: 'full' },
      { path: 'todos', component: DocumentsListComponent, data: { title: 'route.all' } },
      { path: 'lixeira', component: DocumentsTrashbinListComponent, data: { title: 'route.trashBin' } },
      { path: 'grupo', component: DocumentsGroupListComponent, data: { title: 'route.groupDocuments' } },
      { path: 'grupo/:groupId', component: DocumentsGroupListComponent, data: { title: 'route.groupDocuments' } },
      { path: 'organizacao', component: DocumentsOrganizationListComponent, data: { title: 'route.documentOrganization' } },
      { path: 'organizacao/:memberId', component: DocumentsOrganizationMemberListComponent, data: { title: 'route.documentOrganization' } }
    ]
  },
  {
    path: 'pastas',
    component: DocumentsHomeComponent,
    canActivate: [AuthenticationGuard],
    children: [
      { path: '', component: FoldersListComponent, pathMatch: 'full', data: { title: 'route.folders' }, canActivate: [PipefyLogoutGuard] },
      { path: ':folderId', component: DocumentsListComponent, data: { title: 'route.archiveDocuments' } },
      { path: ':folderId/organizacao', component: DocumentsListComponent, data: { title: 'route.sharedDocuments' } },
      { path: 'organizacao/:memberId', component: FoldersListComponent, data: { title: 'route.organizationFolders' } },
      { path: ':folderId/organizacao/:memberId', component: DocumentsListComponent, data: { title: 'route.documentsOrganization' } }
    ]
  },
  {
    path: 'f',
    component: DocumentsHomeComponent,
    canActivate: [AuthenticationGuard],
    children: [
      { path: '', redirectTo: '/pastas', pathMatch: 'full' },
      { path: ':folderId', component: DocumentsListComponent, data: { title: 'route.sharedFolder', shared: true } }
    ]
  },
  {
    path: 'contatos',
    component: ContactsListComponent,
    canActivate: [AuthenticationGuard],
    children: [{ path: '', component: ContactsListComponent, pathMatch: 'full', data: { title: 'route.contacts' } }]
  },

  { path: 'documentos/novo', component: DocumentsNewComponent, data: { title: 'route.documentsNew' }, canActivate: [AuthenticationGuard] },

  { path: 'documentos/:id', component: DocumentsShowComponent, data: { title: 'route.document' } },

  { path: 'documentos/:id/editar', component: DocumentsEditComponent, data: { title: 'route.documentsEdit' } },

  { path: 'documentos/:id/campos', component: DocumentsFieldsEditComponent, data: { title: 'route.documentsFields' } },

  { path: 'assinar/:id', component: DocumentsShowComponent, data: { title: 'route.document' } },

  { path: 'modelos/novo', component: DocumentsTemplateComponent, data: { title: 'route.templates' }, canActivate: [AuthenticationGuard] },

  { path: 'modelos/:id', component: DocumentsFillTemplateComponent, data: { title: 'route.templates' }, canActivate: [AuthenticationGuard] },

  { path: 'modelos/:id/editar', component: DocumentsTemplateComponent, data: { title: 'route.templates' }, canActivate: [AuthenticationGuard] },

  { path: 'dinamicos/novo', component: DocumentsDynamicTemplatesComponent, data: { title: 'route.dynamicTemplates' }, canActivate: [AuthenticationGuard] },
  { path: 'dinamicos/:id/editar', component: DocumentsDynamicTemplatesComponent, data: { title: 'route.dynamicTemplates' }, canActivate: [AuthenticationGuard] },
  { path: 'dinamicos/:id', component: FillDynamicTemplateComponent, data: { title: 'route.dynamicTemplates' }, canActivate: [AuthenticationGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DocumentsRoutingModule {}
